import { Notification } from '../../interfaces/Notification';
import { PromotionDto } from '../../interfaces/PromotionDto';

export const PromoterCodeUrlMap = new Map<string, string>([
  ['PERSONALIZED_ACCESS_CODE', '/account/username/change'],
  ['PROFILE_REVIEW', '/profile'],
  ['ELECTRONIC_FEATURES', '/preferences/communication/change'],
]);

export default function transformPromotions(promotionDtos: PromotionDto[]): Notification[] {
  const Promotions: Notification[] = [];
  if (Array.isArray(promotionDtos)) {
    promotionDtos?.forEach((dto) => {
      Promotions.push({
        id: dto.promoterCode,
        url: dto.urlLink ? dto.urlLink : PromoterCodeUrlMap.get(dto.promoterCode),
        sector: dto.iconCode,
        text: dto.description,
        creationDateUtc: new Date(),
        isDeleting: false,
        seen: false,
        type: 'information',
        visited: false,
        source: 'promotion',
      });
    });
    return Promotions;
  }
  return [];
}
